import { render, staticRenderFns } from "./quesGuide9_2.vue?vue&type=template&id=79840597"
import script from "./quesGuide9_2.vue?vue&type=script&lang=js"
export * from "./quesGuide9_2.vue?vue&type=script&lang=js"
import style0 from "./quesGuide9_2.vue?vue&type=style&index=0&id=79840597&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports